if (process.env.NODE_ENV === 'production') {
  //eslint-disable-next-line
  __webpack_public_path__ = 'https://static.flatfy.com/flatfycom/';
}

require('./App');
